var map = {
	"./ArticleSections": 94104,
	"./ArticleSections.tsx": 94104,
	"./Images/Images": 4453,
	"./Images/Images.tsx": 4453,
	"./Images/ImagesStyles": 32310,
	"./Images/ImagesStyles.ts": 32310,
	"./Images/withImages": 26738,
	"./Images/withImages.tsx": 26738,
	"./Packages/Packages": 43861,
	"./Packages/Packages.tsx": 43861,
	"./Packages/PackagesStyles": 62798,
	"./Packages/PackagesStyles.ts": 62798,
	"./Packages/withPackages": 8100,
	"./Packages/withPackages.tsx": 8100,
	"./Quote/Quote": 65597,
	"./Quote/Quote.tsx": 65597,
	"./Quote/QuoteStyles": 65809,
	"./Quote/QuoteStyles.ts": 65809,
	"./Quote/withQuote": 58827,
	"./Quote/withQuote.tsx": 58827,
	"./Text/Text": 746,
	"./Text/Text.tsx": 746,
	"./Text/TextStyles": 40502,
	"./Text/TextStyles.ts": 40502,
	"./Text/withText": 8617,
	"./Text/withText.tsx": 8617,
	"./withArticleSections": 92702,
	"./withArticleSections.tsx": 92702
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85667;